import { FEATURES } from "../../../../config/features";

export function EmployeeSalaryTab({
  data,
  loading,
}) {

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-3 text-gray-500">Loading salary configuration...</span>
      </div>
    );
  }

  if (!data || (!data.rate && !data.salaryType)) {
    return (
      <div className="p-8 text-center border-2 border-dashed border-gray-200 rounded-lg">
        <p className="text-gray-500">No salary configuration found for this employee.</p>
      </div>
    );
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-PH', {
      style: 'currency',
      currency: 'PHP',
    }).format(amount || 0);
  };

  const isMSC = data.salaryType === "MaintenanceSalaryCombination";

  return (
    <div className="bg-white shadow rounded-lg overflow-hidden border border-gray-200">
      {/* Header Info */}
      <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold text-gray-800">Salary Information</h3>
          <p className="text-sm text-gray-500 uppercase tracking-wider font-medium">
            Type: {data.salaryType}
          </p>
        </div>
        {isMSC && data.mscCode && (
          <span className="bg-blue-100 text-blue-800 text-xs font-bold px-3 py-1 rounded-full border border-blue-200">
            CODE: {data.mscCode}
          </span>
        )}
      </div>

      <div className="p-6">
        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Base Rate Card */}
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
            <p className="text-sm text-blue-600 font-semibold mb-1">
              {data.salaryType === "Monthly" ? "Monthly Rate" : "Daily Rate"}
            </p>
            <p className="text-2xl font-bold text-blue-900">{formatCurrency(data.rate)}</p>
          </div>

          {/* Allowance Card */}
          {FEATURES.EMPLOYEE_INFORMATION_UTILIZE_MSC_USE_ALLOWANCE && (
            <div className="bg-green-50 p-4 rounded-lg border border-green-100">
              <p className="text-sm text-green-600 font-semibold mb-1">Allowance</p>
              <p className="text-2xl font-bold text-green-900">{formatCurrency(data.allowance)}</p>
              <p className="text-xs text-green-500 mt-2">Regular monthly allowance</p>
            </div>
          )}
        </div>

        {/* MSC Benefits Section */}
        {isMSC && data.benefits && data.benefits.length > 0 && (
          <div className="mt-8">
            <h4 className="text-sm font-bold text-gray-700 mb-4 uppercase tracking-wide">
              Operation Benefits (OB)
            </h4>
            <div className="border border-gray-100 rounded-lg overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Benefit Name</th>
                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">Amount</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {data.benefits.map((benefit) => (
                    <tr key={benefit.id}>
                      <td className="px-4 py-3 text-sm text-gray-700">{benefit.benefitName}</td>
                      <td className="px-4 py-3 text-sm text-right font-mono font-semibold text-gray-900">
                        {formatCurrency(benefit.amount)}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50">
                    <td className="px-4 py-2 text-sm font-bold text-gray-900 text-right">Total Benefits:</td>
                    <td className="px-4 py-2 text-sm font-bold text-gray-900 text-right">
                      {formatCurrency(data.benefits.reduce((acc, curr) => acc + curr.amount, 0))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};